<form [formGroup]="formData">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Received Date</label>
          <input type="date" class="form-control" formControlName="received_date" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Tracking Number</label>
          <input
            type="text"
            class="form-control"
            formControlName="tracking_number"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Received By</label>
          <input type="text" class="form-control" formControlName="received_by" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="">Received At</label>
          <input type="text" class="form-control" formControlName="received_at" />
        </div>
      </div>
    </div>
    <hr />
    <fieldset>
      <legend>
        <div class="flex justify-content-between">
          <div>Purchase Orders / Items</div>
        </div>
        <div class="flex justify-content-between align-center">
          <div>
            <button class="btn btn-info" (click)="addPOItems()">
              Add Purchase Orders / Items
            </button>
          </div>
          <div
            class="flex gap-6"
            *ngFeatureFlag="
              featureFlag.NEW_PURCHASE_ORDER_LIST_VIEW;
              isDisabled: false
            "
          >
            <div class="block form-group">
              <label for=""> Bulk Update Warehouse </label>
              <lum-warehouse-search-dropdown
                [selected]="formData.get('bulkWarehouse').value"
                (selectItemEvent)="onSelectBulkUpdateWarehouse($event)"
              ></lum-warehouse-search-dropdown>
              <!-- <select
                class="form-control"
                (change)="onWarehouseFormSelect($event.target.value)"
                formControlName="bulkWarehouseId"
              >
                <option value="">--None--</option>
                <option *ngFor="let w of warehouses" [value]="w.id">
                  {{ w.location_name }}
                </option>
              </select> -->
              <div *ngIf="formData.get('bulkWarehouseId').disabled">
                <small class="text-gray-700">Add item/s to select warehouse.</small>
              </div>
            </div>
            <div class="block form-group">
              <label for=""> Bulk Update Location </label>
              <lum-warehouse-search-dropdown
                [selected]="formData.get('bulkLocation').value"
                [warehouseId]="formData.get('bulkWarehouseId').value"
                [disabled]="formData.get('bulkLocationId').disabled"
                (selectItemEvent)="onSelectBulkUpdateLocation($event)"
              ></lum-warehouse-search-dropdown>
              <!-- <select
                class="form-control"
                (change)="onLocationFormSelect($event.target.value)"
                formControlName="bulkLocationId"
              >
                <option [value]=""></option>
                <option
                  *ngFor="
                    let loc of locations
                      | filterById
                        : {
                            parent_id: formData.value.bulkWarehouseId
                          }
                  "
                  [value]="loc.id"
                >
                  {{ loc.location_name }}
                </option>
              </select> -->
              <div *ngIf="formData.get('bulkLocationId').disabled">
                <small class="text-gray-700"
                  >Select a warehouse to select location.</small
                >
              </div>
            </div>
          </div>
        </div>
      </legend>
      <table class="table">
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>SKU</th>
            <th width="200">Product Name</th>
            <th>Warehouse</th>
            <th *ngIf="itemLocationEnabled">Location</th>
            <th *ngIf="ftLocationBins && ftLotTracking">Lot</th>
            <th>Qty</th>
            <th>Unit</th>
            <th>Unit Price</th>
            <th>Line Total</th>
            <th>Tags</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody formArrayName="items">
          <tr
            *ngFor="
              let item of formData['controls'].items['controls'];
              let idx = index
            "
            [formGroupName]="idx"
            [ngClass]="{
              'table-danger':
                rfqs[item.value.rfq_id]?.status === productStatus.DELETED ||
                !item.value.rfq_id,
            }"
          >
            <td>
              <a
                href="javascript:;"
                class="duplicate text-info"
                (click)="duplicateRow(item, idx)"
              >
                <i class="fas fa-copy"></i>
              </a>
            </td>
            <td class="text-nowrap">{{ item.value.sku || 'N/A' }}</td>
            <td>
              {{ item.value.item }}
            </td>
            <td>
              <lum-warehouse-search-dropdown
                [selected]="item.value.warehouse"
                (selectItemEvent)="onSelectWarehouse($event, idx)"
              ></lum-warehouse-search-dropdown>
              <!-- <select
                class="form-control"
                name="wh{{ idx + 1 }}"
                formControlName="warehouse_id"
                (change)="onWarehouseChange(idx)"
              >
                <option *ngFor="let w of warehouses" [value]="w.id">
                  {{ w.location_name }}
                </option>
              </select> -->
            </td>
            <td *ngIf="itemLocationEnabled">
              <lum-warehouse-search-dropdown
                [warehouseId]="item.value.warehouse_id"
                [selected]="item.value.location"
                (selectItemEvent)="onSelectLocation($event, idx)"
              ></lum-warehouse-search-dropdown>
              <!-- <select
                class="form-control"
                name="loc{{ idx + 1 }}"
                formControlName="location_id"
                (click)="loadWarehouseLocations(idx)"
                (change)="setBulkUpdateLocationValue()"
              >
                <option value=""></option>
                <option
                  *ngFor="
                    let loc of locations
                      | filterById
                        : {
                            parent_id: formArrayItems.at(idx).value.warehouse_id
                          }
                  "
                  [value]="loc.id"
                >
                  {{ loc.location_name }}
                </option>
              </select> -->
            </td>
            <td
              *ngIf="enabledBinLocationAndLotTracking(formArrayItems.at(idx).value)"
            >
              <lum-rfq-lot-search-dropdown
                [rfqId]="item.value.rfq_id"
                [selected]="item.value.lot"
                (selectLotEvent)="onSelectLot($event, idx)"
                (createNewLotEvent)="onOpenCreateLotDialog(item, idx)"
              ></lum-rfq-lot-search-dropdown>
              <!-- <select
                class="form-control lot-id"
                name="lot{{ idx + 1 }}"
                formControlName="lot_id"
                (change)="onLotChange($event, idx)"
              >
                <option
                  *ngFor="
                    let lot of rfqLots
                    | filterById
                      : {
                          rfq_id: formArrayItems.at(idx).value.rfq_id
                        }
                  "
                  [value]="lot.id"
                >
                  {{ lot.lot_number }}
                </option>
                <option value="createNewLot">Create a new Lot</option>
              </select> -->
            </td>
            <td
              *ngIf="
                ftLotTracking &&
                !enabledBinLocationAndLotTracking(formArrayItems.at(idx).value)
              "
              class="flex-container"
            ></td>
            <td>
              <input
                type="number"
                class="form-control text-right"
                name="{{ 'qty' + idx }}"
                formControlName="quantity"
                (change)="computeLineTotal(idx)"
                lumDecimalLimit
              />
            </td>
            <td class="valign-td">
              <span *ngIf="item.value.received_uom_id && item.value.rfq_id">
                {{ getUomName(item.value.rfq_id, item.value.received_uom_id) }}
              </span>
            </td>
            <td>
              <input
                type="number"
                class="form-control text-right"
                name="{{ 'price' + idx }}"
                formControlName="unit_price"
                (change)="computeLineTotal(idx)"
              />
            </td>
            <td>
              <input
                type="number"
                class="form-control text-right"
                name="{{ 'total' + idx }}"
                formControlName="line_total"
                (change)="computeTotal()"
                lumDecimalLimit
              />
            </td>
            <td>
              <ng-select
                [items]="tags"
                formControlName="tags"
                bindValue="id"
                [searchFn]="customTagsSearchFn"
                multiple="true"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span
                    class="ng-value-icon right"
                    (click)="clear(item)"
                    aria-hidden="true"
                    >Ã—</span
                  >
                  <span [innerHTML]="item.name" class="d-inline"></span>
                </ng-template>
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-index="index"
                  let-search="searchTerm"
                >
                  <h6 [innerHTML]="item.name"></h6>
                </ng-template>
              </ng-select>
            </td>
            <td>
              <a href="javascript:;" (click)="removeItem(idx)">
                <i class="fas fa-times text-danger"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group text-right">
            <label for="">Total Units</label>
            <h3>{{ totalUnits | decimalPlaces }}</h3>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group text-right">
            <label for="">Total Cost</label>
            <h3>{{ totalCost | lumCurrency }}</h3>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="activeModal.dismiss('')"
      [disabled]="loading"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="button"
      class="btn btn-success"
      [disabled]="loading"
      (click)="save()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
    >
      <i class="fas fa-check"></i> Save Receiving Report
    </button>
  </div>
</form>
